import './speakersfilter.less'

import {ProgramModel} from 'models/program/ProgramModel'
import React from 'react'
import {useEvent} from 'util/eventcontext'
import {style} from 'util/style'
import {Filter, FilterClear} from 'views/filter/filter'
import {Theme} from 'views/theme'

const styles = style('speakersfilter')

export type SpeakersFilters = {
	track?: string
	domain?: string
	sort?: string
	type?: string
}

export const SpeakersFilter: React.FC<{
	program: ProgramModel
	filters: SpeakersFilters
	setFilters: (filters: SpeakersFilters) => void
}> = ({program, filters, setFilters}) => {
	const event = useEvent()
	const domains = program.speakers.reduce(
		(acc, speaker) => [...acc, ...speaker.domains],
		[] as Array<string>
	)
	const domainsUnique = domains.filter(function(item, pos) {
		return domains.indexOf(item) === pos
	})

	return (
		<div className={styles()} id="speakers">
			<Theme.OuterContainer>
				<Theme.Container>
					<div className={styles('row')}>
						<div className={styles('left')}>
							{!event.isDarkTheme && (
								<Filter
									placeholder="Tracks"
									choices={[
										{key: 'itfbelgium', label: 'ITF Belgium'},
										{key: 'fwddive', label: 'Forward Dive'},
										{key: 'deeptechdive', label: 'Deep Tech Dive'},
										{key: 'bizffwd', label: 'Business Fast Forward'}
									]}
									value={filters.track}
									onChange={track => setFilters({...filters, track})}
								/>
							)}
							<Filter
								placeholder="Domain"
								choices={domainsUnique.map(domain => ({
									key: domain,
									label: domain
								}))}
								value={filters.domain}
								onChange={domain => setFilters({...filters, domain})}
							/>
							{program.speakerTypes.length > 0 && (
								<Filter
									placeholder="Type"
									choices={program.speakerTypes.map(type => ({
										key: type,
										label: type
									}))}
									value={filters.type}
									onChange={type => setFilters({...filters, type})}
								/>
							)}
							<FilterClear onClear={() => setFilters({sort: filters.sort})} />
						</div>
						<div className={styles('right')}>
							<Filter
								text="Sort by"
								placeholder="Sort by"
								choices={
									event.url === '/2024/world'
										? [
												{key: 'default', label: 'Default'},
												{key: 'firstname', label: 'First name A-Z'},
												{key: 'lastname', label: 'Last name A-Z'}
										  ]
										: [
												{key: 'firstname', label: 'First name A-Z'},
												{key: 'lastname', label: 'Last name A-Z'}
										  ]
								}
								value={filters.sort}
								onChange={sort => setFilters({...filters, sort})}
							/>
						</div>
					</div>
				</Theme.Container>
			</Theme.OuterContainer>
		</div>
	)
}
